"use strict";
/*
 * Created on 22. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");
/**
 * Requires recalculation of prices.
 * @author Radek Beran
 */


var RequiresRecalculation =
/*#__PURE__*/
function (_ValidationResultFlag) {
  _inherits(RequiresRecalculation, _ValidationResultFlag);

  function RequiresRecalculation() {
    _classCallCheck(this, RequiresRecalculation);

    return _possibleConstructorReturn(this, _getPrototypeOf(RequiresRecalculation).apply(this, arguments));
  }

  _createClass(RequiresRecalculation, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return RequiresRecalculation;
}(ValidationResultFlag_1.ValidationResultFlag);

exports.RequiresRecalculation = RequiresRecalculation;
RequiresRecalculation.TAG = ValidationResultFlag_1.ValidationResultFlag.register(RequiresRecalculation);
RequiresRecalculation.INSTANCE = new RequiresRecalculation();